import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getMappedFields = async (
  appId: string,
  serviceApi?: string | string[],
  dashboardOption?: boolean
) => {
  const serviceApiContext = Array.isArray(serviceApi)
    ? serviceApi.join("&serviceApi=")
    : serviceApi;
  const { data } = await IBModuleApi.get(
    `${
      IBModuleApi.defaults.baseURL
    }/${urlContexts.console}/rest/1.0/cs/mappedfield?appId=${appId}${
      serviceApi ? `&serviceApi=${serviceApiContext}` : ""
    }`
  );

  if (dashboardOption) {
    return {
      header: data.header,
      data: data.data.filter((field: any) => field.dashboardoption.length > 0),
    };
  }
  return data;
};

export const createMappedFields = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/mappedfield?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateMappedFields = async (updateInfo: number, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/mappedfield?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteMappedFields = async (
  mappedFieldId: number,
  appId: string
) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/mappedfield/${mappedFieldId}?appId=${appId}`
  );

  return data;
};

export const getProductFields = async (
  appId: string,
  productId: number,
  usageType?: string
) => {
  const { data } = await IBModuleApi.get(
    `${
      IBModuleApi.defaults.baseURL
    }/${urlContexts.console}/rest/1.0/cs/productfield/${productId}?appId=${appId}${
      usageType ? `&usageType=${usageType}` : ""
    }`
  );

  return data;
};

export const createProductFields = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/productfield?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateProductFields = async (
  updateInfo: number,
  appId: string
) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/productfield?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteProductFields = async (
  productFieldId: number,
  appId: string
) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/productfield/${productFieldId}?appId=${appId}`
  );

  return data;
};

export const getTransactionFields = async (
  appId: string,
  transactionId: number
) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transactionfield/${transactionId}?appId=${appId}`
  );

  return data;
};

export const createTransactionFields = async (
  createInfo: any,
  appId: string
) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transactionfield?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateTransactionFields = async (
  updateInfo: number,
  appId: string
) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transactionfield?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteTransactionFields = async (
  transactionFieldId: number,
  appId: string
) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/transactionfield/${transactionFieldId}?appId=${appId}`
  );

  return data;
};
